export default function Agpercent(props) {
    return (
        <div className="agpie" style={{"--p":props.val,"--b":"10px","--c":"#0b0"}} >
            <div style={{display: 'inline'}}>
                <span>{props.val}</span>
                <span style={{fontSize: '12px'}}>%</span>
            </div>
        </div>
    )
}